import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const Acquiring = ({
  size,
  type,
  theme,
  className,
  dataTestId = "acquiring-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path d="M5.418 3.984a.4.4 0 0 0-.4.4v2.971c0 .221.179.4.4.4h5.166a.4.4 0 0 0 .4-.4v-2.97a.4.4 0 0 0-.4-.4H5.418ZM10.984 9.797a.77.77 0 1 1-1.542 0 .77.77 0 0 1 1.542 0ZM10.213 12.776a.77.77 0 1 0 0-1.542.77.77 0 0 0 0 1.542ZM6.56 9.797a.77.77 0 1 1-1.542 0 .77.77 0 0 1 1.541 0ZM5.788 12.776a.77.77 0 1 0 0-1.542.77.77 0 0 0 0 1.542ZM8.771 9.797a.77.77 0 1 1-1.541 0 .77.77 0 0 1 1.541 0ZM8 12.776a.77.77 0 1 0 0-1.542.77.77 0 0 0 0 1.542Z"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M5.018.937c0-.184.149-.333.333-.333h5.3c.184 0 .333.15.333.333v.651h.277a2 2 0 0 1 2 2v9.582c0 .774-.457 1.526-1.259 1.788a13.13 13.13 0 0 1-4.001.646c-1.7 0-3.144-.366-4.002-.646-.802-.262-1.259-1.014-1.259-1.788V3.588a2 2 0 0 1 2-2h.278v-.65ZM4.74 2.922a.667.667 0 0 0-.666.666v9.582c0 .268.15.459.339.52.772.253 2.071.58 3.588.58 1.516 0 2.815-.327 3.588-.58.188-.061.339-.252.339-.52V3.588a.667.667 0 0 0-.667-.666h-6.52Z"/>
  </SVGIcon>
);